import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import React from "react";
import ExamCard from "./ExamCard";
import StarIcon from "@mui/icons-material/Star";
import RatingCard from "./RatingCard";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import { styled } from "@mui/system";

const IconBox = styled(Box)({
  height: "27px",
  width: "34px",
  borderRadius: "5px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginLeft: "10px",
});

function ExamsSeciton({ loading: initialLoading, exams: initialExams }) {
  const [loading, setLoading] = useState(initialLoading);
  const [exams, setExams] = useState(initialExams);

  useEffect(() => {
    setLoading(initialLoading);
    setExams(initialExams);
  }, [initialLoading, initialExams]);

  const examscategory = [
    { ExamVendorName: "Cisco", AverageRating: 5.0, DiscussionCount: 1 },
    { ExamVendorName: "CompTIA", AverageRating: 5.0, DiscussionCount: 0 },
    { ExamVendorName: "Fortinet", AverageRating: 5.0, DiscussionCount: 0 },
    { ExamVendorName: "HP", AverageRating: 5.0, DiscussionCount: 0 },
    { ExamVendorName: "Microsoft", AverageRating: 5.0, DiscussionCount: 0 },
    { ExamVendorName: "Salesforce", AverageRating: 5.0, DiscussionCount: 0 },
    { ExamVendorName: "VMware", AverageRating: 5.0, DiscussionCount: 0 },
    { ExamVendorName: "SAP", AverageRating: 5.0, DiscussionCount: 3 },
    { ExamVendorName: "Oracle", AverageRating: 5.0, DiscussionCount: 1 },
    { ExamVendorName: "Nursing", AverageRating: 5.0, DiscussionCount: 0 },
  ];

  return (
    <Container>
      <Grid container rowGap={5} columnGap={5}>
        <Grid
          item
          md={6.5}
          xs={12}
          sx={{
            background: "#EBEBEB",
            borderRadius: "5px",
            paddingLeft: "12px",
            maxHeight: "800px",
          }}
        >
          <Typography
            variant="h2"
            sx={{
              textAlign: "center",
              fontSize: { xs: "25px", md: "30px" },
              fontFamily: "Poppins",
              fontWeight: 700,
              mt: 2,
            }}
          >
            RECENT EXAMS
          </Typography>

          <Grid
            container
            spacing={2}
            sx={{
              px: 2,
              mt: 1,
              mb: 5,
              overflow: "auto",
              paddingRight: "6px",
            }}
          >
            {loading ? (
              <Stack
                mt={1}
                width="100%"
                direction="row"
                justifyContent="center"
              >
                <CircularProgress disableShrink />
              </Stack>
            ) : (
              exams
                ?.sort((a, b) => new Date(b.Date) - new Date(a.Date))
                ?.map((exam, i) => (
                  <Grid
                    key={i}
                    item
                    md={4}
                    xs={6}
                    sx={{
                      padding: "15px 15px !important",
                      margin: "0 auto",
                      paddingRight: "5px",
                    }}
                  >
                    <ExamCard exam={exam} />
                  </Grid>
                ))
            )}
          </Grid>
        </Grid>
        <Grid
          item
          md={5}
          xs={12}
          sx={{
            background: "#EBEBEB",
            borderRadius: "5px",
            maxHeight: "800px",
            overflowY: "scroll",
          }}
        >
          <Typography
            variant="h2"
            sx={{
              textAlign: "center",
              fontSize: { xs: "24px", md: "30px" },
              fontFamily: "Poppins",
              fontWeight: 700,
              mt: 2,
            }}
          >
            TOP RATED CATEGORIES
          </Typography>
          <Stack width="100%" direction="row" justifyContent="space-evenly">
            <Stack direction="row" alignItems="center">
              <Typography
                sx={{
                  fontSize: { xs: "14px", md: "18px" },
                  fontFamily: "Poppins",
                  fontWeight: 600,
                }}
              >
                Ratings :
              </Typography>
              <IconBox sx={{ background: "#27B1BB" }}>
                <StarIcon sx={{ color: "#FFD500" }} />
              </IconBox>
            </Stack>
            <Stack direction="row" alignItems="center">
              <Typography
                sx={{
                  fontSize: { xs: "14px", md: "18px" },
                  fontFamily: "Poppins",
                  fontWeight: 600,
                }}
              >
                Comments :
              </Typography>
              <IconBox sx={{ background: "#444647" }}>
                <ChatBubbleIcon sx={{ fontSize: "22px", color: "#F0F0F0" }} />
              </IconBox>
            </Stack>
          </Stack>
          {loading ? (
            <Stack mt={1} width="100%" direction="row" justifyContent="center">
              <CircularProgress disableShrink />
            </Stack>
          ) : (
            examscategory.map((item, i) => (
              <Box key={i}>
                <RatingCard examscategory={item} />
              </Box>
            ))
          )}
        </Grid>
      </Grid>
    </Container>
  );
}
export default ExamsSeciton;
